<template>
  <div class="formation">
    <app-header :background-name="'wallpaper_lahochi.jpg'">
      <h1>Stéphanie Lefebvre</h1>
      <h2>Formation LaHoChi</h2>
    </app-header>

    <div class="content">
      <article>
        <div class="bloc">
          <h1>Formation LaHoChi</h1>

          <p>
            A partir de septembre 2024, des sessions de formation au LaHoChi seront organisées au cabinet.
          </p>

          <p>Tarif de la formation : <b>150 euros par personne.</b></p> 

          <p>
            Pour tout demande de renseignement ou d'inscription, merci de me contacter au 06 67 75 10 80
          </p>

        </div>
      </article>
    </div>
  </div>
</template>

<script>
import AppHeader from '@/components/Header'

export default {
  name: 'Formation',
  components: { AppHeader }
}
</script>

<style lang="scss" scoped>
.formation {
  display: flex;
  flex-direction: column;
  flex: 1;

  .content {
    position: relative;
    text-align: center;
    background-color: #f1fae7;
    align-items: center;
    display: flex;
    flex-direction: column;
    overflow: hidden;

    @media screen and (max-width: 680px) {
      overflow: auto;
    }

    article {
      @include custom-article();
      .bloc { 
        text-align: center;
      }

      img {
        position: absolute;
        z-index: 0;
        opacity: .5;

        &.left {
          bottom: -2vw;
          left: -1vw;
        }

        &.right {
          top: -1vw;
          right: -1vw;
        }
      }
    }
  }
}
</style>
